import { useIntl } from 'react-intl';

import { Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';
import { BaseCard } from '@/components/emotion-detector/shared/BaseCard';
import { useEmotionDetection, useWebcamStart } from '@/hooks/emotion-detector';

import PreviewOverlayComponent from './components/PreviewOverlayComponent';
import {
	ButtonContainer,
	CaptureDescription,
	CaptureTitle,
	StatusText,
	StyledButton,
	Video,
	VideoContainer,
} from './styles';
import { getButtonText } from './utils';

interface EmotionCaptureProps {
	emotionDetection: ReturnType<typeof useEmotionDetection>;
	isVisible: boolean;
}

export default function EmotionCapture({ emotionDetection, isVisible }: EmotionCaptureProps) {
	const { formatMessage } = useIntl();
	const { videoRef, preview, status, detecting, startWebcam, detectEmotion } = emotionDetection;

	useWebcamStart(isVisible, startWebcam);

	if (!isVisible) return null;

	return (
		<BaseCard data-card="capture">
			<CaptureTitle>
				<Text el="h2">{formatMessage(messages.cameraCaptureTitle)}</Text>
			</CaptureTitle>

			<CaptureDescription>
				<Text el="p">{formatMessage(messages.cameraCaptureDescription)}</Text>
			</CaptureDescription>

			<VideoContainer>
				<Video ref={videoRef} autoPlay muted />
				{preview && <PreviewOverlayComponent preview={preview} />}
			</VideoContainer>

			<StatusText>{status}</StatusText>

			<ButtonContainer>
				<StyledButton onPress={detectEmotion} isDisabled={detecting}>
					{getButtonText(detecting, formatMessage)}
				</StyledButton>
			</ButtonContainer>
		</BaseCard>
	);
}
